import StorageManager from './StorageManager'
import { analytics } from './Analytics/Analytics'
import { mixtilesAxios } from '../utils/ApiUtils'

const MARKETING_CONSENT_GIVEN_KEY = 'gdprMarketingConsentGiven'

class GdprManager {
  setMarketingConsentGiven(source, email) {
    this._updateMarketingConsent()
    StorageManager.set(MARKETING_CONSENT_GIVEN_KEY, true) // We don't use it, but might need it in the future
    analytics.track('Web Email Marketing Consent Given', {
      Source: source,
      Email: email,
    })
    this.sendEmailedAllowedEvent(source, email)
  }

  sendEmailedAllowedEvent(source, email) {
    analytics.track('Web Email Marketing Allowed', {
      Source: source,
      Email: email,
    })
  }

  didGetMarketingConsent() {
    return !!StorageManager.get(MARKETING_CONSENT_GIVEN_KEY)
  }

  _updateMarketingConsent() {
    return mixtilesAxios
      .post('v4/updateMarketingConsent', { didConsent: true })
      .then((response) => response.data)
  }
}

export const gdprManager = new GdprManager()
